import React from "react";
import styled, { withTheme } from "styled-components";
import EntityList from "../../EntityList/EntityList";
import { CONTROLS_POSITION } from "../../../Common/constants";
import { Link } from "react-router-dom";
import { getPercentage } from "../../../Common/utils";

const StyledActiveProperties = styled.div`
  display: flex;
  height: 40px;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;
`;

function customEntityToListValuesMapper({ entities }) {
  return entities.map(originalEntity => {
    const entity = { ...originalEntity };
    entity.margin = originalEntity.margin ? getPercentage(originalEntity.margin / 100) : 0;
    return entity;
  })
}

class PartnersList extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      entities: [],
    };
  }

  componentDidMount() {}

  componentWillUnmount() {}

  activePropertiesCell = ({ field, entity }) => {
    const fieldName = field && field.fieldName;
    const value = entity && entity[fieldName];
    return (
      <Link
        style={{ color: this.props.theme.regularTextColor }}
        target="_blank"
        to={`/crm/properties?partner=${entity.ticker}`}>
        <StyledActiveProperties>{value}</StyledActiveProperties>
      </Link>
    );
  };

  render() {
    const {
      name,
      entityName,
      validation,
      fields,
      renderers,
      sorting,
      allowClone,
      allowDelete,
      allowExport,
      exportFileName,
      reorder,
      filterFields,
      showTotalRecords,
    } = this.props.config;
    const {
      entities,
      loading,
      entityError,
      entityResult,
      handleCreate,
      handleEdit,
      success,
    } = this.props;

    renderers.numActiveProperties = this.activePropertiesCell;
    return (
      <EntityList
        filterFields={filterFields}
        loading={loading}
        entityName={entityName}
        entities={entities}
        validation={validation}
        renderers={renderers}
        name={name}
        fields={fields}
        entityError={entityError}
        entityResult={entityResult}
        handleCreate={handleCreate}
        handleEdit={handleEdit}
        currentLocale={this.props.config.locale}
        success={success}
        sorting={sorting}
        allowClone={allowClone}
        allowDelete={allowDelete}
        allowExport={allowExport}
        exportFileName={exportFileName}
        reorder={reorder}
        maxColumnWidth={400}
        horizontalScroll
        controlsPosition={CONTROLS_POSITION.TOP}
        showTotalRecords={showTotalRecords}
        customEntityToListValuesMapper={customEntityToListValuesMapper}
        hasFilters
      />
    );
  }
}

PartnersList.propTypes = {};

PartnersList.defaultProps = {};

export default withTheme(PartnersList);
